<ckeditor #myEditor [editor]="Editor" [config]="Config" (ready)="onReady($event)" (keyup.enter)="saveText()" (change)="onChange($event);" [(ngModel)]="EditorText"></ckeditor>



<div style="display: flex; flex-direction: row;" *ngFor="let audio of audioList">
  <button (click)="downloadAudio(audio)">Descargar {{ audio.word }}</button>
</div>
